import { NgFor, NgTemplateOutlet } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { FuseNavigationItem, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { AvailableLangs, TranslocoService } from '@ngneat/transloco';
import { MenuModel } from 'app/models/menu.model';
import { NavigationAdapter } from 'app/navigation/navigationAdapter';
import { catchError, take, throwError } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { SharedService } from 'app/services/shared.service';
import { Router } from '@angular/router';
import { MenuService } from 'app/services/menu.service';
import { environment } from 'environments/environment';
import { ConfigService } from 'app/services/config.service';

@Component({
    selector: 'languages',
    templateUrl: './languages.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'languages',
    standalone: true,
    imports: [MatButtonModule, CommonModule, MatIcon, MatMenuModule, NgTemplateOutlet, NgFor],
})
export class LanguagesComponent implements OnInit, OnDestroy {
    flagCodes: any = {};
    currentUrl: string;
    route: string;
    activeLang: string = '';
    availableLangs: AvailableLangs = [];

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private _translocoService: TranslocoService,
        private _sharedService: SharedService,
        private _menuService: MenuService,
        private configService: ConfigService,
        private http: HttpClient,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.currentUrl = window.location.href;
        this.route = this.currentUrl.split(`${environment.baseUrl}/`)[1];

        this.configService.getLanguages().subscribe((result: any) => {
            

            result = result.data;
            this._translocoService.setAvailableLangs(result.map(l => { return { id:l.Lingua.value, label: l.Lingua.text} }));
            this.availableLangs = this._translocoService.getAvailableLangs();

            result.forEach(l => {
                this.flagCodes[l.Lingua.value] = l.FlagCode;
            });

            var selectedLang = localStorage.getItem('lang');
            if (selectedLang) {
                this.activeLang = selectedLang;
                this.setActiveLang(selectedLang);
            } else {
                this.activeLang = result.find(l => l.Default).Lingua.value;
                this.setActiveLang(this.activeLang);
            }

            this._translocoService.langChanges$.subscribe((activeLang) => {
                this.activeLang = activeLang;
                localStorage.setItem('lang', activeLang);
                this._changeDetectorRef.markForCheck();
            });

            this._updateNavigation(this.activeLang);
        });
    }

    ngOnDestroy(): void { }

    setActiveLang(lang: string): void {
        localStorage.setItem('lang', lang);
        this._translocoService.setActiveLang(lang);
    }

    trackByFn(index: number, item: any): any {
        return item?.id || index;
    }

    private _updateNavigation(_lang: string): void {
       
        this._menuService.getMenu()
            .pipe(
                take(1),
                catchError(error => {
                    //console.error('Errore durante il recupero dei dati di navigazione:', error);
                    return throwError(error);
                })
            )
            .subscribe((data: MenuModel[]) => {
                //console.log('Dati dei menu ottenuti:', data); 
                const navigationData: FuseNavigationItem[] = data.map(item => NavigationAdapter.adapt(item));

                this.updateNavigationInFrontend(navigationData);
                //console.log('Dati di navigazione adattati:', navigationData); 

                const currentMenu = data.find(menu => menu.link === this.route);
                //console.log('Menu corrente:', currentMenu); 
                if (currentMenu) {
                    this._sharedService.updateMenuData([currentMenu]); 
                }
            });
    }

    private updateNavigationInFrontend(newNavigationData: FuseNavigationItem[]): void {
        const navComponent = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>('mainNavigation');
        if (navComponent) {
            navComponent.navigation = newNavigationData;
            navComponent.refresh();
        }
    }

    updateLanguage(lang: string): void {
        this._translocoService.setActiveLang(lang);
        this._translocoService.load(lang);
    }
}
